// extracted by mini-css-extract-plugin
export default {"skillsContainer":"styles_skillsContainer__NMs7S"};